<template>

    <div class="canvas::editor-website-editors-panels-Tabs">

        <div v-if="!panelSearching" class="grid custom-grid-cols relative z-0 rounded-lg divide-x divide-gray-200">

            <button v-for="tab in tabs"
                    :key="tab"
                    @click="tabSelected = tab"
                    :class="['tab-btn', { 'bg-white': tabSelected === tab, 'bg-indigo-50': tabSelected !== tab }]"
                    class="group text-sm py-1"
            >
                {{ tab }}
            </button>

        </div>

        <div class="tabs">

            <div class="tab" v-for="tab in tabs" v-show="panelSearching || tabSelected === tab">
                <slot :name="tab" />
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: {
            tabs: Array
        },

        data()
        {
            return {
                tabSelected: _.first(this.tabs),
                panelSearching: false,
            }
        },

    }

</script>

<style lang="scss" scoped>

    .canvas\:\:editor-website-editors-panels-Tabs {

        .custom-grid-cols {
            grid-template-columns: repeat( auto-fit, minmax(min(6rem, 100%), 1fr) );
        }

        .tab-btn {
            padding: 6px 10px;
            cursor: pointer;
            border: none;
            outline: none;

            &.active {
                border-bottom: 2px solid #3899ec;
            }
        }

        .tab {
            //border-top: 1px solid #ccc;
        }

    }

</style>
